import { render, staticRenderFns } from "./addNewEmailCampaigns.vue?vue&type=template&id=4c4090ba"
import script from "./addNewEmailCampaigns.vue?vue&type=script&lang=js"
export * from "./addNewEmailCampaigns.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports